// router
import Vue from 'vue'
import VueI18n from 'vue-i18n'
//import {Checkbox,CheckboxGroup,Table,TableColumn,Message} from 'element-ui'
import css from './css/element-ui-style/index.css'
import ElementUI from 'element-ui'
/*import enLocale from 'element-ui/lib/locale/lang/en'
import chLocale from 'element-ui/lib/locale/lang/zh-CN'*/
import 'babel-polyfill'  //lmz:解决引入 async  await

import VueRouter from 'vue-router'
//import axios from './http'
import axios from 'axios'
import api from './api'
import zhLocale from './lang/zh-cn'
import enLocale from './lang/en-us'
// import CenLocale from '../static/custom-en'
// import CzhLocale from '../static/custom-zh'

import './css/index.css'
// 导入动态加载器
// import { loadLocale } from './i18n-loader'
// import dataV from '@jiaminghi/data-view';
// Vue.use(dataV);

const signin = resolve => require(['./components/signin.vue'], resolve)
const bigScreen = resolve => require(['./components/bigScreen/index.vue'], resolve)
const bigScreenConfigure = resolve => require(['./components/bigScreenConfigure/index.vue'], resolve) //大屏配置
const monitorPageDevice = resolve => require(['./components/monitorPageDevice/index.vue'], resolve) //大屏配置
const preview = resolve => require(['./components/bigScreenConfigure/preview.vue'], resolve) //大屏配置
const index = resolve => require(['./components/index'], resolve)
const deviceList = resolve => require(['./components/deviceList.vue'], resolve)
const deviceStatus = resolve =>
  require(['./components/deviceStatus.vue'], resolve)

const deviceSetDeploy = resolve =>
  require(['./components/setDeploy/index.vue'], resolve)
const deviceUpgrade = resolve =>
  require(['./components/deviceUpgrade.vue'], resolve)
const deviceConfig = resolve =>
  require(['./components/deviceConfig.vue'], resolve)
const deviceTask = resolve => require(['./components/task.vue'], resolve)
const server=resolve=>require(['components/server.vue'],resolve)
const callRecord=resolve=>require(['components/callRecord.vue'],resolve)
const callConfig=resolve=>require(['components/callConfig.vue'],resolve)
const deviceInf=resolve=>require(['components/deviceInf.vue'],resolve)
const manageUser = resolve => require(['./components/user.vue'], resolve)
const managePrivilege = resolve =>
  require(['./components/privilege.vue'], resolve)
const manageGroup = resolve =>
  require(['./components/deviceGroup.vue'], resolve)
const manageParam_mx = resolve =>
  require(['./components/parameter_mx.vue'], resolve)
const manageParam_om = resolve =>
  require(['./components/parameter_om.vue'], resolve)
const manageParam_voip = resolve =>
  require(['./components/voipParam/index.vue'], resolve)
const managePackage = resolve => require(['./components/package.vue'], resolve)
const manageSyslog = resolve => require(['./components/syslog.vue'], resolve)
const templateManage_om = resolve =>
  require(['./components/templateManage_om.vue'], resolve)
const templateManage_mx = resolve =>
  require(['./components/templateManage_mx.vue'], resolve)
const templateManage_voip = resolve =>
  require(['./components/voipTemplate/index.vue'], resolve)
const config_voip = resolve =>
  require(['./components/voipConfig/index.vue'], resolve)
const phoneSource = resolve =>
  require(['./components/phoneSource/index.vue'], resolve)
const templateManage_file = resolve =>
  require(['./components/templateManage_file.vue'], resolve)
const manageRoute = resolve => require(['./components/route.vue'], resolve)
const domain = resolve => require(['./components/domain.vue'], resolve)
const deviceInfo = resolve => require(['./components/deviceInfo.vue'], resolve)
const ipphoneInfo = resolve =>
  require(['./components/ipphoneInfo/index.vue'], resolve)

const voipInfo = resolve => require(['./components/voipInfo.vue'], resolve)
const cloudID = resolve => require(['./components/cloudID.vue'], resolve)
const taskInfo = resolve => require(['./components/taskInfo.vue'], resolve)
const paramTask = resolve => require(['./components/paramTask.vue'], resolve)
const setParamTask = resolve =>
  require(['./components/setParamTask.vue'], resolve)
const setFileTask = resolve =>
  require(['./components/setFileTask.vue'], resolve)
const setConfigTask = resolve =>
  require(['./components/setConfigTask.vue'], resolve)
const rebootDevice = resolve =>
  require(['./components/rebootDevice.vue'], resolve)
const confBackTask = resolve =>
  require(['./components/confBackTask.vue'], resolve)
const templateBackTask = resolve =>
  require(['./components/templateBackTask.vue'], resolve)
const setParamTemTask = resolve =>
  require(['./components/setParamTemTask.vue'], resolve)
const logBackup = resolve => require(['./components/logBackup.vue'], resolve)
const curLogBackup = resolve =>
  require(['./components/curLogBackup.vue'], resolve)
const sysInfo = resolve => require(['./components/sysInfo.vue'], resolve)
const dataBackup = resolve => require(['./components/dataBackup.vue'], resolve)
const monitor = resolve => require(['./components/monitor.vue'], resolve)
const alarmRename = resolve =>
  require(['./components/alarmRename.vue'], resolve)
const alarmRule = resolve => require(['./components/alarmRule.vue'], resolve)
const deviceInspection = resolve =>
  require(['./components/deviceInspection.vue'], resolve)
const monitorGroup = resolve => require(['./components/monitorGroup'], resolve)
const directSell = resolve => require(['./components/directSell.vue'], resolve)
const directDevice = resolve =>
  require(['./components/directDevice.vue'], resolve)
const directDeviceList = resolve =>
  require(['./components/directDeviceList.vue'], resolve)
const api_app = resolve => require(['./components/app.vue'], resolve)
const license = resolve => require(['./components/license.vue'], resolve)
const licenseOm8000 = resolve =>
  require(['./components/licenseOm8000.vue'], resolve)
const licenseUms = resolve => require(['./components/licenseUms.vue'], resolve)
const licenseNewlync = resolve => require(['./components/licenseNewlync.vue'], resolve)
const licenseNewlyncAS = resolve => require(['./components/licenseNewlyncAS.vue'], resolve)
const licenseRP = resolve => require(['./components/licenseRP.vue'], resolve)
const licenseExpire = resolve => require(['./components/licenseExpire.vue'], resolve)
const licensethrough = resolve => require(['./components/licensethrough.vue'], resolve)
const licenseTLS = resolve => require(['./components/licenseTLS.vue'], resolve)

const neehau = resolve => require(['./components/neehau.vue'], resolve)
const neehauStat = resolve =>
  require(['./components/neehauStat/index.vue'], resolve)
// const neehauStat = resolve => require(['./components/neehauStat'],resolve)
// const appStat = resolve => require(['./components/appStat.vue'],resolve)
const appStat = resolve => require(['./components/appStat/index.vue'], resolve)

const test = resolve => require(['./components/test/index.vue'], resolve)
const detail = resolve => require(['./components/detail.vue'], resolve)
// 新增设备重定向服务管理
const acsService = resolve => require(['./components/acsService.vue'], resolve)
const autoprovisionTemplate = resolve => require(['./components/autoprovisionTemp.vue'], resolve)
const autoprovisionDevice = resolve => require(['./components/autoprovisionDevice.vue'], resolve)
const metaprofile = resolve => require(['./components/metaprofile/metaprofile.vue'], resolve) //自定义模板
const metaprofileConfig = resolve => require(['./components/metaprofile/metaprofileConfig.vue'], resolve) //自定义模板
const autoprofileConfig = resolve => require(['./components/autoprofileConfig.vue'], resolve) //自定义模板
const sysAlarmConfig = resolve => require(['./components/sysAlarmConfig.vue'], resolve) //系统告警通知配置
import store from './store/state'
import * as types from './store/types'

/*Vue.config.debug = true

Vue.config.productionTip = false

Vue.config.devtools = false*/

// 将axios挂载到prototype上，在组件中可以直接使用this.axios访问
Vue.prototype.axios = axios

// console.log(transfer2);

Vue.use(VueRouter)
// Vue.use(transfer2);

/*Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Message)*/

/*定义一级路由显示区*/
const mainRouter = {
  template: '<router-view></router-view>'
}

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}
    // new navigation.
    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash
    }
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // cords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0
      position.y = 0
    }
    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    return position
  }
}

/*路由*/
const routes = [

  { path: '', component: signin },
  { path: '/', component: signin },
  { path: '/login', component: signin },
  { path: '/logout', component: signin },
  { path: '/bigScreen', component: bigScreen },
  {  //大屏预览
    path: '/preview',
    component: preview
  },
  {
    path: '/index',
    component: index,
    children: [
      {
        path: '/',
        component: deviceStatus
      },
      {
        path: 'list',
        component: deviceList
      },
      {
        path: 'status',
        component: deviceStatus
      },
      {
        path: 'config',
        component: deviceConfig
      },
      {
        path: 'upgrade',
        component: deviceUpgrade
      },
      {
        path: 'setDeploy',
        component: deviceSetDeploy
      },
      {
        path: 'task',
        component: deviceTask
      },
      {
        path: 'server',
        component: server
      },
      {
        path:'callRecord',
        component:callRecord
      },
      {
        path:'deviceInf',
        component:deviceInf
      },
      {
        path:'callConfig',
        component:callConfig
      },
      {
        path: 'monitor',
        component: monitor
      },
      {
        path: 'user',
        component: manageUser
      },
      {
        path: 'privilege',
        component: managePrivilege
      },
      {
        path: 'parameter_mx',
        component: manageParam_mx
      },
      {
        path: 'parameter_om',
        component: manageParam_om
      },
      {
        path: 'parameter_voip',
        component: manageParam_voip
      },
      {
        path: 'group',
        component: manageGroup
      },
      {
        path: 'templateManage_om',
        component: templateManage_om
      },
      {
        path: 'templateManage_mx',
        component: templateManage_mx
      },
      {
        path: 'templateManage_voip',
        component: templateManage_voip
      },
      {
        path: 'config_voip',
        component: config_voip
      },
      {
        path: 'phoneSource',
        component: phoneSource,
      },
      {
        path: 'templateManage_file',
        component: templateManage_file
      },
      {
        path: 'route',
        component: manageRoute
      },
      {
        path: 'package',
        component: managePackage
      },
      {
        path: 'syslog',
        component: manageSyslog
      },
      {
        path: 'domains',
        component: domain
      },
      {
        path: 'cloudID',
        component: cloudID
      },
      {
        path: 'deviceInfo',
        component: deviceInfo
      },
      {
        path: 'ipphoneInfo',
        component: ipphoneInfo
      },
      {
        path: 'voipInfo',
        component: voipInfo
      },
      {
        path: 'taskInfo',
        component: taskInfo
      },
      {
        path: 'paramTask',
        component: paramTask
      },
      {
        path: 'setParamTask',
        component: setParamTask
      },
      {
        path: 'setFileTask',
        component: setFileTask
      },
      {
        path: 'setConfigTask',
        component: setConfigTask
      },
      {
        path: 'rebootDevice',
        component: rebootDevice
      },
      {
        path: 'confBackupTask',
        component: confBackTask
      },
      {
        path: 'templateBackupTask',
        component: templateBackTask
      },
      {
        path: 'setParamTemTask',
        component: setParamTemTask
      },
      {
        path: 'logBackup',
        component: logBackup
      },
      {
        path: 'curLogBackup',
        component: curLogBackup
      },
      {
        path: 'sysInfo',
        component: sysInfo
      },
      {
        path: 'dataBackup',
        component: dataBackup
      },
      {
        path: 'alarmRename',
        component: alarmRename
      },
      {
        path: 'alarmRule',
        component: alarmRule
      },
      {
        path: 'deviceInspection',
        component: deviceInspection
      },
      {
        path: 'monitorGroup',
        component: monitorGroup
      },
      {
        path: 'directSell',
        component: directSell
      },
      {
        path: 'directDevice',
        component: directDevice
      },
      {
        path: 'directDeviceList',
        component: directDeviceList
      },
      {
        path: 'maintenance',
        component: directSell
      },
      {
        path: 'api_app',
        component: api_app
      },
      {
        path: 'license',
        component: license
      },
      {
        path: 'licenseOm8000',
        component: licenseOm8000
      },
      {
        path: 'licenseUms',
        component: licenseUms
      },
	  {
	    path: 'licensethrough',
	    component: licensethrough
	  },
	  {
	    path: 'licenseNewlync',
	    component: licenseNewlync
	  },
    {
      path: 'licenseNewlyncAS',
      component: licenseNewlyncAS
    },
	  {
	    path: 'licenseRP',
	    component: licenseRP
	  },
	  {
	    path: 'licenseExpire',
	    component: licenseExpire
	  },
	  {
	    path: 'licenseTLS',
	    component: licenseTLS
	  },

      {
        path: 'neehau',
        component: neehau
      },
      {
        path: 'neehauStat',
        component: neehauStat
      },
      {
        path: 'appStat',
        component: appStat
      },
      {
        path: 'test',
        component: test
      },
      {
        path: 'detail',
        component: detail
      },
      {
        path: 'acs_service',
        component: acsService
      },
      {
        path: 'sysAlarm',
        component: sysAlarmConfig
      },
      {
        path: 'autoprovision_template',
        component: autoprovisionTemplate
      },
      {
        path: 'autoprovision_device',
        component: autoprovisionDevice
      },
      {
        path: 'metaprofile',
        component: metaprofile
      },
      {
        name:'metaprofileConfig',
        path: 'metaprofileConfig',
        component: metaprofileConfig
      },
      {
        name:'autoprofileConfig',
        path: 'autoprofileConfig',
        component: autoprofileConfig
      },
      { //bigScreenConfigure 大屏配置
        name:'bigScreenConfigure',
        path: 'bigScreenConfigure',
        component: bigScreenConfigure
      },
      { //bigScreenConfigure 大屏配置
        name:'monitorPageDevice',
        path: 'monitorPageDevice',
        component: monitorPageDevice
      },

    ]
  }
]
// 3. 创建 router 实例，然后传 `routes` 配置
const router = new VueRouter({
  mode: 'history',
  scrollBehavior,
  routes: routes
})

Vue.use(VueI18n)
Vue.use(ElementUI)

Vue.config.lang = localStorage.getItem('umslang')
  ? localStorage.getItem('umslang')
  : 'zh-cn'

// 创建 i18n 实例（先放基础包）
// const i18n = new VueI18n({
//   locale: defaultLang,
//   messages: {
//     'zh-cn': {},
//     'en': {}
//   }
// })
function mergeLocaleByTopKey(baseLocale, customLocale) {
  for (let key in customLocale) {
    const baseItem = baseLocale[key] || {}
    baseLocale[key] = {
      ...baseItem,
      ...customLocale[key]
    }
  }
}

function loadAndMergeLocale(lang) {
  const isZh = lang === 'zh-cn'
  const baseLocale = isZh ? zhLocale : enLocale
  const file = isZh ? 'custom-zh.json' : 'custom-en.json'

  return axios.get(`/static/${file}?t=${Date.now()}`)
    .then(res => {
      const customLocale = res.data || {}

      // 🔥 核心：JSON 覆盖 JS
      mergeLocaleByTopKey(baseLocale, customLocale)

      // 🔥 把“合并后的 JS 语言包”重新塞回 i18n
       Vue.locale(lang, baseLocale)
    })
}
function initAllLocales() {
  return Promise.all([
    loadAndMergeLocale('zh-cn'),
    loadAndMergeLocale('en')
  ]).then(() => {
    // i18n.locale = localStorage.getItem('umslang') || 'zh-cn'
  })
}
// 加载并设置语言（Promise 版）
// function loadAndSetLocale(lang) {
//   const baseLocale = lang === 'zh-cn' ? zhLocale : enLocale

//   return loadCustomLocale(lang).then(customLocale => {
//     const finalLocale = mergeLocale(baseLocale, customLocale)
//    if (Vue.locale) {
//          Vue.locale(lang, finalLocale)
//        }

//        // 设置当前语言
//        i18n.locale = lang
//   })
// }

// 初始化执行
// loadAndSetLocale(defaultLang)
// 页面刷新时，重新赋值token
if (window.localStorage.getItem('token')) {
  store.commit(types.LOGIN, window.localStorage.getItem('token'))
}

//设置cookie,增加到vue实例方便全局调用
//vue全局调用的理由是，有些组件所用到的接口可能需要session验证，session从cookie获取
//当然，如果session保存到vuex的话除外
Vue.prototype.setCookie = (c_name, value, expiredays) => {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie =
    c_name +
    '=' +
    escape(value) +
    (expiredays == null ? '' : ';expires=' + exdate.toGMTString())
}

//获取cookie、
function getCookie(name) {
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) return arr[2]
  else return null
}
Vue.prototype.getCookie = getCookie

//删除cookie
Vue.prototype.delCookie = name => {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null)
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
}

// 4. 创建和挂载根实例。
// 记得要通过 router 配置参数注入路由，
// 从而让整个应用都有路由功能

// 初始化执行并在完成后再启动 Vue
// initAllLocales().then(() => {
initAllLocales().then(() => {
  const app = new Vue({
    store,
    axios,
    router,
    // i18n,
    render: h => h(mainRouter),
    //监听路由检查登录
    watch: {
      $router: 'checkLogin',
      $route(to, from) {
        if (to.name !== '/index/sysInfo') {
          this.$root.eventHub.$emit('clearSta')
          this.$root.eventHub.$off('clearSta')
        }
      }
    },
    created() {
      if (window.location.href.split('/')[1] != 'bigScreen') {
        this.checkLogin()
      }
    },
    data: {
      eventHub: new Vue()
    },
    mounted() {
      ;(Vue.prototype.showErrorMessage = errCode => {
        let key = errCode
        if (key === 10001) {
          console.log(10001)
          location.href = '/'
        } else if (this.$t('CodeData.' + key)) {
          let str = ""
          if (this.$t('CodeData.' + key + '[2]')) {
            str = ": " + this.$t('CodeData.' + key + '[2]')
          }
          api.failMsg(
            this.$t('CodeData.' + key + '[1]') + str
          )
        } else {
          api.failMsg(this.$t('share.opf'))
        }
      })
      Vue.prototype.setLang = function (lang) {
        localStorage.setItem('umslang', lang)

        // ⭐ 5.x 正确切换方式
        Vue.config.lang = lang
      }
    },
    methods: {
      checkLogin() {
        //检查是否已登录
        if (!localStorage.getItem('user')) {
          this.$router.push('/login')
        }
      }
    }
  }).$mount('#app')

})


//切换路由前，判断系统密码是否为默认密码
// router.beforeEach((to, from, next) => {
//   if (localStorage.getItem("account")) {
//     if (localStorage.getItem("account")==="sysadmin"&&localStorage.getItem("pass")==="admin@123") {
//      window.location.href="/index";
//     }
//     else {
//       next();
//     }
//   }
//   else {
//     next();
//   }
// })

// 现在，应用已经启动了！



// WEBPACK FOOTER //
// ./src/router.js